export default __webpack_public_path__ + "static/media/arrow-down.0da2be0a.svg";